import { LoginModal } from 'components/organisms/modals/LoginModal'
import { NotVerifiedModal } from 'components/organisms/modals/NotVerifiedModal'
import { ResetModal } from 'components/organisms/modals/ResetModal'
import { SignupModal } from 'components/organisms/modals/SignupModal'
import { TermsModal } from 'components/organisms/modals/TermsModal'
import type {
  LoginModalProps,
  NotVerifiedModalProps,
  ResetModalProps,
  SignupModalProps,
  TermsModalProps,
} from './types'
import { useModal } from './hooks'
import { EModalType } from './enums'

interface ModalsWrapperProps {
  modalProps: {
    login: LoginModalProps
    signup: SignupModalProps
    reset: ResetModalProps
    terms: TermsModalProps
    notVerified: NotVerifiedModalProps
  }
}

const modalComponents = {
  [EModalType.LOGIN]: LoginModal,
  [EModalType.SIGN_UP]: SignupModal,
  [EModalType.RESET]: ResetModal,
  [EModalType.TERMS]: TermsModal,
  [EModalType.NOT_VERIFIED]: NotVerifiedModal,
}

export const ModalsWrapper = ({ modalProps }: ModalsWrapperProps) => {
  const activeModal = useModal()

  if (!activeModal) return null

  const ModalComponent = modalComponents[activeModal]

  if (!ModalComponent) return null

  return <ModalComponent {...modalProps[activeModal]} />
}
